module.exports = __webpack_public_path__ + "colormelife-coloring-page-printable-vegetation-1.png";